import apolloClient from "../../connection/apolloClient";
import SAVE from "../../mutations/save";

const executeSave = async (itemId, itemType) => {
  let result;
  try {
    result = await apolloClient.mutate({
      mutation: SAVE,
      variables: {
        item_id: itemId,
        item_type: itemType,
        toggle_save: false
      }
    });
  } catch (e) {
    throw new Error(e);
  }

  return result;
};

export default executeSave;
